import React, { useEffect, useState } from "react";
import "./admin_settings.css";
import CustomButton from "../../../components/CustomButton/custombutton";
import { Form, Formik } from "formik";
import CustomInput from "../../../components/CustomInput/CustomInput";
import * as Yup from "yup";
import previewLogo from "../../../images/defaultLogo.png";
import Modal from "../../../components/Modal/modal";
import AntFileUpload from "../../../components/AntFileUpload/AntFileUpload";
import api from "../../../api/api";
import apiUtil from "../../../api/apiUtil";
import getToken from "../../getToken";

const AdminPanelSettings = () => {
  const [showModal, setShowModal] = useState(false);
  const [fileSizeError, setFileSizeError] = useState(false);
  const [previewFiles, setPreviewFiles] = useState(null);

  const hideModal = () => {
    setShowModal(false);
    setFileSizeError(false);
  };

  const [activeTab, setActiveTab] = useState(1);

  const changeActiveTabHandler = (newTab) => {
    setActiveTab(newTab);
  };

  const [image, setImage] = useState([]);
  const getLogoImage = () => {
    api
      .get("Admin/GetSettingDetailByAdmin", { Name: "Logo" }, getToken())
      .then((result) =>
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setImage(response.data.data);
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            setImage([]);
            console.log(error);
          }
        )
      );
  };

  let brandId = localStorage.getItem("brandId");
  const clickBtnSaveLogo = (e) => {
    e.preventDefault();

    if (previewFiles) {
      const info = {
        id: "7650d3d7-7917-40f5-7f15-08db4229fde5",
        organizationId: "fc7af43c-a309-11ed-b26e-6045bdd63acb",
        brandId: brandId,
        name: "Logo",
        valueInText: previewFiles[0].url.replace(/^data:(.*,)?/, ""),
        valueInInt: "0",
        valueInJson: null,
      };
      api
        .post("Admin/UpdateSettingByAdmin", info, getToken())
        .then((result) => {
          apiUtil.parseResult(
            result,
            (response) => {
              console.log(response);
              if (response.data.code === 401) {
                alert(response.data.message);
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.code === 200) {
                alert("Logo saved successfully!!");
                getLogoImage();
                window.location.reload();
              } else {
                alert(response.data.message);
              }
            },
            (error, type) => {
              console.log(error);
            }
          );
        });
    }
  };

  const [imageSize, setImageSize] = useState([]);
  const getImageSize = () => {
    api
      .get("Admin/GetSettingDetailByAdmin", { Name: "LogoSize" }, getToken())
      .then((result) =>
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response.data.data);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setImageSize(response.data.data);
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            setImageSize([]);
            console.log(error);
          }
        )
      );
  };

  const onSubmitImageSizeConfigHandler = (values, actions) => {
    console.log(values);
    const info = {
      id: "9154e36a-e508-11ed-b26e-6045bdd63acb",
      organizationId: "fc7af43c-a309-11ed-b26e-6045bdd63acb",
      brandId: brandId,
      name: "LogoSize",
      valueInText: "",
      valueInInt: values.backend_logo_size,
      valueInJson: null,
    };

    api.post("Admin/UpdateSettingByAdmin", info, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          console.log(response);
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            alert("Backend logo size saved successfully!!");
            getImageSize();
          } else {
            alert(response.data.message);
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });
    actions.setSumitting(false);
  };

  const [appVersionDetail, setAppVersionDetail] = useState({});
  const getAppVersionConfig = () => {
    api
      .get("Admin/GetAdminAppSettingByAdmin", {}, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setAppVersionDetail(response.data.data);
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            console.log(error);
          }
        );
      });
  };

  const AppVersionConfigValidation = Yup.object().shape({
    versionNo: Yup.string()
      .test("app_verion_number", "Please enter decimal numbers only.", (val) =>
        /^(\d+\.)*\d+$/.test(val)
      )
      .required("Please enter app version number."),
    notiTitle: Yup.string().required(
      "Please enter version notification title."
    ),
    notiMsg: Yup.string().required(
      "Please enter version notification message."
    ),
    playstoreUrl: Yup.string().required("Please enter google play url."),
    iosUrl: Yup.string().required("Please enter app store url."),
  });

  const onSubmitVersionAppConfigHandler = (values, actions) => {
    const versionAppConfig = {
      isAdmin: true,
      ...values,
    };

    api
      .post("Admin/UpdateAppSetting", versionAppConfig, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              alert("App setting saved successfully!!");
              getAppVersionConfig();
            } else {
              alert(response.data.message);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });

    actions.setSumitting(false);
  };

  useEffect(() => {
    getLogoImage();
    getImageSize();
    getAppVersionConfig();
  }, []);

  return (
    <div className="admin-settings">
      <div className="menuBtnList">
        <CustomButton
          text="Image Section"
          addIcon={false}
          className={`btnMenu ${activeTab === 1 ? "active" : ""}`}
          onClick={() => changeActiveTabHandler(1)}
        />
        {/* <CustomButton
          text="Image Size"
          addIcon={false}
          className={`btnMenu ${activeTab === 2 ? "active" : ""}`}
          onClick={() => changeActiveTabHandler(2)}
        /> */}
        <CustomButton
          text="Version Configuration"
          addIcon={false}
          className={`btnMenu ${activeTab === 3 ? "active" : ""}`}
          onClick={() => changeActiveTabHandler(3)}
        />
      </div>

      {activeTab === 1 && (
        <div className="admin-settings-container">
          <div className=" Actions space_between mb-3">
            <h4 className=" title_text mt-2 mb-0">Backend Logo</h4>
            <button className="btnEdit" onClick={() => setShowModal(true)}>
              Edit
            </button>
          </div>

          {/* Show Modal */}
          <Modal showModal={showModal} close={true} hideModal={hideModal}>
            <div className="uploadLogo">
              <Formik
                initialValues={{
                  files: null,
                }}
                validationSchema={Yup.object().shape({
                  files: Yup.array()
                    .nullable()
                    .required("Please choose the images."),
                })}
                validateOnBlur={false}
                enableReinitialize={true}
                onSubmit={(values, actions) => {
                  setPreviewFiles(values.files);
                  setShowModal(false);
                  actions.setSubmitting(false);
                }}
              >
                {({ values, errors, touched, setFieldValue }) => (
                  <>
                    {!values.files && previewFiles && previewFiles.length > 0 && (
                      <img
                        src={previewFiles[0].url}
                        className="imgUpload"
                        alt="imageUpload"
                      />
                    )}

                    <h4>Upload</h4>
                    <Form className=" edit-logo-form">
                      <div className={`${fileSizeError && "mb-3"}`}>
                        <AntFileUpload
                          name="files"
                          inputText={
                            <>
                              <span>Drag and drop here </span>
                              <span>or</span>
                              <button
                                className="btnChooseFiles"
                                onClick={() => setFileSizeError(false)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    setFileSizeError(false);
                                  }
                                }}
                              >
                                Choose Files
                              </button>
                            </>
                          }
                          // fileList={values.files}
                          aspectRatio={9 / 3}
                          // maxSizeInByte={358400}
                          multiiple="false"
                          imageQuality={0.8}
                          accept={".png, .jpg, .jpeg"}
                          onChange={({ fileList: newFileList }) => {
                            if (newFileList.length > 0) {
                              // Only a file upload. if the fileList length is greater than 1, remove index 0;
                              if (newFileList.length > 1) {
                                newFileList.shift();
                              }
                              newFileList = newFileList.map((file) => {
                                if (file.size <= imageSize.valueInInt * 1024 * 1024) {
                                  return {
                                    ...file,
                                    status: "done",
                                    percent: 100,
                                    response: "Success",
                                  };
                                } else {
                                  return {
                                    ...file,
                                    status: "error",
                                    percent: 100,
                                    response: "Failed",
                                  };
                                }
                              });
                              const successFiles = newFileList.filter(
                                (file) => file.status !== "error"
                              );
                              const failedFiles = newFileList.filter(
                                (file) => file.status === "error"
                              );
                              if (failedFiles.length > 0) {
                                setFileSizeError(true);
                              }
                              setFieldValue("files", successFiles);
                            } else {
                              setFieldValue("files", null);
                              setPreviewFiles(null);
                            }
                          }}
                          onRemove={(file) => {
                            if (file.url) {
                              setFieldValue("deletedImage", [
                                ...values.deletedImage,
                                file,
                              ]);
                            }
                          }}
                        />
                        {fileSizeError && (
                          <div className=" error__text">
                            image size (mb) is greater than specified image
                            size ({imageSize.valueInInt ? imageSize.valueInInt : 5} mb).
                          </div>
                        )}
                      </div>
                      <div className="d-block text-center">
                          <button type="submit" className="btnConfirm" disabled={fileSizeError}>
                            Confirm
                          </button>
                      </div>
                    </Form>
                  </>
                )}
              </Formik>
            </div>
          </Modal>

          <img
            src={previewFiles && previewFiles.length > 0 ? previewFiles[0].url : image.valueInText?? previewLogo}
            className={`imgLogo ${image.valueInText?? 'animated'} border border-1`}
            alt="imageLogo"
          />

          <div className="Actions justify-content-end">
            <button type="button" className="button btnCancel">
              Cancel
            </button>
            <button
              type="submit"
              className="button btnSave"
              onClick={clickBtnSaveLogo}
            >
              Save
            </button>
          </div>
        </div>
      )}

      {activeTab === 2 && (
        <div className="admin-settings-container">
          <h4 className=" title_text mt-2">Image Size Configuration (MB)</h4>
          <Formik
            initialValues={{
              backend_logo_size: imageSize.valueInInt
                ? imageSize.valueInInt
                : 0,
            }}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              backend_logo_size: Yup.string()
                .required("Please enter backend logo size.")
                .test("amount", "Please enter number only", (val) =>
                  /^\d+$/.test(val)
                ),
            })}
            validateOnBlur={false}
            onSubmit={(values, actions) => {
              onSubmitImageSizeConfigHandler(values, actions);
            }}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form className="row">
                <div className="col-12 mt-2">
                  <CustomInput
                    name="backend_logo_size"
                    type="number"
                    label="Backend Logo Size"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-3">
                  <div className="Actions justify-content-end">
                    <button type="button" className="button btnCancel">
                      Cancel
                    </button>
                    <button type="submit" className="button btnSave">
                      Save
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}

      {activeTab === 3 && (
        <div className="admin-settings-container">
          <h4 className=" title_text mt-2">Admin App Version Configuration</h4>
          <Formik
            initialValues={{
              versionNo: appVersionDetail.versionNo
                ? appVersionDetail.versionNo
                : "",
              notiTitle: appVersionDetail.notiTitle
                ? appVersionDetail.notiTitle
                : "",
              notiMsg: appVersionDetail.notiMsg ? appVersionDetail.notiMsg : "",
              playstoreUrl: appVersionDetail.playstoreUrl
                ? appVersionDetail.playstoreUrl
                : "",
              iosUrl: appVersionDetail.iosUrl ? appVersionDetail.iosUrl : "",
            }}
            enableReinitialize={true}
            validationSchema={AppVersionConfigValidation}
            validateOnBlur={false}
            onSubmit={(values, actions) => {
              onSubmitVersionAppConfigHandler(values, actions);
            }}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form className="row">
                <div className="col-12 mt-2">
                  <CustomInput
                    name="versionNo"
                    type="text"
                    label="App Version Number"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-2">
                  <CustomInput
                    name="notiTitle"
                    type="text"
                    label="Version Notification Title"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-2">
                  <CustomInput
                    name="notiMsg"
                    label="Version Notification Message"
                    textarea="true"
                  />
                </div>
                <div className="col-12 mt-2">
                  <CustomInput
                    name="playstoreUrl"
                    type="text"
                    label="Google Play URL"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-2">
                  <CustomInput
                    name="iosUrl"
                    type="text"
                    label="App Store URL"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-3">
                  <div className="Actions justify-content-end">
                    <button type="button" className="button btnCancel">
                      Cancel
                    </button>
                    <button type="submit" className="button btnSave">
                      Save
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}
    </div>
  );
};

export default AdminPanelSettings;
